import { LoadableComponent } from 'Utils/LoadableComponent/LoadableComponent';

export const PagerRedesignLanding = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/Landing',
  loader: () => import(/* webpackChunkName: "PagerLanding" */ 'Redesign_Funnel/containers/pages/Landing'),
  modules: ['pager'],
});

export const PagerCanceled = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/Canceled',
  loader: () => import(/* webpackChunkName: "PagerCanceled" */ 'Redesign_Funnel/containers/pages/Canceled'),
  modules: ['pager'],
});

export const PagerRejected = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/Rejected',
  loader: () => import(/* webpackChunkName: "PagerRejected" */ 'Redesign_Funnel/containers/pages/Rejected'),
  modules: ['pager'],
  timeout: 11000,
});

export const PagerApply = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/Apply',
  loader: () => import(/* webpackChunkName: "PagerApply" */ 'Redesign_Funnel/containers/pages/Apply'),
  modules: ['pager'],
  timeout: 21000,
});

export const PagerScoring = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/Scoring',
  loader: () => import(/* webpackChunkName: "PagerScoring" */ 'Redesign_Funnel/containers/pages/Scoring'),
  modules: ['pager'],
  timeout: 37000,
});

export const PagerApproving = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/Approving',
  loader: () => import(/* webpackChunkName: "PagerApproving" */ 'Redesign_Funnel/containers/pages/Approving'),
  modules: ['pager'],
  timeout: 30000,
});

export const PagerIdentityVerification = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/IdentityVerification',
  loader: () => import(/* webpackChunkName: "PagerIdentityVerification" */ 'Redesign_Funnel/containers/pages/IdentityVerification'),
  modules: ['pager'],
});

export const PagerValidating = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/Validating',
  loader: () => import(/* webpackChunkName: "PagerValidating" */ 'Redesign_Funnel/containers/pages/Validating'),
  modules: ['pager'],
  timeout: 17000,
});

export const PagerOffering = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/Offering',
  loader: () => import(/* webpackChunkName: "PagerOffering" */ 'Redesign_Funnel/containers/pages/Offering'),
  modules: ['pager'],
  timeout: 10000,
});

export const PagerTransfer = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/Transfer',
  loader: () => import(/* webpackChunkName: "PagerTransfer" */ 'Redesign_Funnel/containers/pages/Transfer'),
  modules: ['pager'],
  timeout: 10000,
});

export const CreateApplicationError = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/CreateApplicationError',
  loader: () => import(/* webpackChunkName: "PagerCreateApplicationError" */ 'Redesign_Funnel/containers/pages/CreateApplicationError'),
  modules: ['pager'],
  timeout: 10000,
});

export const PagerEditMobile = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/Validating/Edit',
  loader: () => import(/* webpackChunkName: "PagerEditMobile" */ 'Redesign_Funnel/containers/pages/Validating/Edit'),
  modules: ['pager'],
});

export const PagerProfile = LoadableComponent({
  label: 'Containers/pages/Profile',
  loader: () => import(/* webpackChunkName: "PagerProfile" */ 'Containers/pages/Profile'),
  modules: ['pager'],
});

export const PagerProfileInStore = LoadableComponent({
  label: 'Containers/pages/ProfileInStore',
  loader: () => import(/* webpackChunkName: "PagerProfileInStore" */ 'Containers/pages/ProfileInStore'),
  modules: ['pager'],
});

export const PagerDetails = LoadableComponent({
  label: 'Containers/pages/Details',
  loader: () => import(/* webpackChunkName: "PagerDetails" */ 'Containers/pages/Details'),
  modules: ['pager'],
});

export const PaymentConfirmationDetails = LoadableComponent({
  label: 'Containers/pages/PaymentConfirmationDetails',
  loader: () => import(/* webpackChunkName: "PaymentConfirmationDetails" */ 'Containers/pages/PaymentConfirmationDetails'),
  modules: ['pager'],
});

export const PagerReferences = LoadableComponent({
  label: 'Containers/pages/References',
  loader: () => import(/* webpackChunkName: "PagerReferences" */ 'Containers/pages/References'),
  modules: ['pager'],
});

export const LoanPaymentMethods = LoadableComponent({
  label: 'Containers/pages/LoanPaymentMethod',
  loader: () => import(/* webpackChunkName: "LoanPaymentMethod" */ 'Containers/pages/LoanPaymentMethod'),
  modules: ['pager'],
});

export const DirectDebit = LoadableComponent({
  label: 'Containers/pages/LoanPaymentMethod/DirectDebit',
  loader: () => import(/* webpackChunkName: "DirectDebit" */ 'Containers/pages/LoanPaymentMethod/DirectDebit'),
  modules: ['pager'],
});

export const DirectDebitSantander = LoadableComponent({
  label: 'Containers/pages/LoanPaymentMethod/DirectDebitSantander',
  loader: () => import(/* webpackChunkName: "DirectDebitSantander" */ 'Containers/pages/LoanPaymentMethod/DirectDebitSantander'),
  modules: ['pager'],
});

export const PaymentStatus = LoadableComponent({
  label: 'Containers/pages/LoanPaymentMethod/PaymentStatus',
  loader: () => import(/* webpackChunkName: "PaymentStatus" */ 'Containers/pages/LoanPaymentMethod/PaymentStatus'),
  modules: ['pager'],
});

export const PersonalLoan = LoadableComponent({
  label: 'Containers/pages/PersonalLoan',
  loader: () => import(/* webpackChunkName: "Installments" */ 'Containers/pages/PersonalLoan'),
  modules: ['pager'],
});

export const LoanDetail = LoadableComponent({
  label: 'Containers/pages/LoanDetail',
  loader: () => import(/* webpackChunkName: "LoanDetail" */ 'Containers/pages/LoanDetail'),
  modules: ['pager'],
});

export const TransactionDetail = LoadableComponent({
  label: '@kueski-consumer-portal/containers/pages/TransactionDetail',
  loader: () => import(/* webpackChunkName: "Repayments" */ '@kueski-consumer-portal/containers/pages/TransactionDetail'),
  modules: [],
});

export const PagerChannels = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/Channels',
  loader: () => import(/* webpackChunkName: "PagerChannels" */ 'Redesign_Funnel/containers/pages/Channels'),
  modules: ['pager'],
  timeout: 13000,
});

export const PagerCodeChannel = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/CodeChannel',
  loader: () => import(/* webpackChunkName: "PagerCodeChannel" */ 'Redesign_Funnel/containers/pages/CodeChannel'),
  modules: ['pager'],
});

export const CreditCapacityOrderSuccess = LoadableComponent({
  label: 'Containers/pages/CreditCapacityOrderSuccess',
  loader: () => import(/* webpackChunkName: "CreditCapacityOrderSuccess" */ 'Containers/pages/CreditCapacityOrderSuccess'),
  modules: ['pager'],
  timeout: 12000,
});

export const CompletedKYC = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/CompletedKYC',
  loader: () => import(/* webpackChunkName: "CompletedKYC" */ 'Redesign_Funnel/containers/pages/CompletedKYC'),
  modules: ['pager'],
  timeout: 13000,
});

export const CreditDetail = LoadableComponent({
  label: 'Containers/pages/CreditDetail',
  loader: () => import(/* webpackChunkName: "CreditCapacityOrderSuccess" */ 'Containers/pages/CreditDetail'),
  modules: ['pager'],
});

export const ContactInformation = LoadableComponent({
  label: 'Containers/pages/ContactInformation',
  loader: () => import(/* webpackChunkName: "ContactInformation" */ 'Containers/pages/ContactInformation'),
  modules: [],
});

export const ContactInformationPhone = LoadableComponent({
  label: 'Containers/pages/ContactInformation/EditPhone',
  loader: () => import(/* webpackChunkName: "ContactInformation" */ 'Containers/pages/ContactInformation/EditPhone'),
  modules: [],
});

export const ValidateIdentity = LoadableComponent({
  label: 'Containers/pages/ValidatingIdentity',
  loader: () => import(/* webpackChunkName: "ContactInformation" */ 'Containers/pages/ValidatingIdentity'),
  modules: [],
});

export const EmailVerification = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/EmailVerification',
  loader: () => import(/* webpackChunkName: "EmailVerification" */ 'Redesign_Funnel/containers/pages/EmailVerification'),
  modules: [],
  timeout: 26000,
});

export const EvaluationCardRegistration = LoadableComponent({
  label: 'Src/admin_money_accounts/pages/Funnel4Ecosystem',
  loader: () => import(/* webpackChunkName: "EvaluationCardRegistration" */ 'Src/admin_money_accounts/pages/Funnel4Ecosystem'),
  modules: [],
});

export const TestPersonalLoans = LoadableComponent({
  label: 'Src/admin_money_accounts/pages/TestPersonalLoans.page',
  loader: () => import(/* webpackChunkName: "TestPages" */ 'Src/admin_money_accounts/pages/TestPersonalLoans.page'),
  modules: [],
});

export const AddAccount = LoadableComponent({
  label: 'Src/admin_money_accounts/pages/AddAccount.page',
  loader: () => import(/* webpackChunkName: "AccountManagement" */ 'Src/admin_money_accounts/pages/AddAccount.page'),
  modules: [],
});

export const ListAccounts = LoadableComponent({
  label: 'Src/admin_money_accounts/pages/ListAccounts.page',
  loader: () => import(/* webpackChunkName: "AccountManagement" */ 'Src/admin_money_accounts/pages/ListAccounts.page'),
  modules: [],
});

export const AddCard = LoadableComponent({
  label: 'Src/admin_money_accounts/pages/AddCard.page',
  loader: () => import(/* webpackChunkName: "CardManagement" */ 'Src/admin_money_accounts/pages/AddCard.page'),
  modules: [],
});

export const ListCards = LoadableComponent({
  label: 'Src/admin_money_accounts/pages/ListCards.page',
  loader: () => import(/* webpackChunkName: "CardManagement" */ 'Src/admin_money_accounts/pages/ListCards.page'),
  modules: [],
});

export const AddCardAccount = LoadableComponent({
  label: 'Src/admin_money_accounts/pages/AddCardAccount.page',
  loader: () => import(/* webpackChunkName: "CardManagement" */ 'Src/admin_money_accounts/pages/AddCardAccount.page'),
  modules: [],
});

export const ListCardsAndAccounts = LoadableComponent({
  label: 'Src/admin_money_accounts/pages/ListCardsAndAccounts.page',
  loader: () => import(/* webpackChunkName: "CardManagement" */ 'Src/admin_money_accounts/pages/ListCardsAndAccounts.page'),
  modules: [],
});

export const Home = LoadableComponent({
  label: 'Containers/pages/Home',
  loader: () => import(/* webpackChunkName: "Home" */ 'Containers/pages/Home'),
  modules: [],
});

export const Repayments = LoadableComponent({
  label: 'Containers/pages/Repayments',
  loader: () => import(/* webpackChunkName: "Repayments" */ 'Containers/pages/Repayments'),
  modules: [],
});

export const RepaymentsPayment = LoadableComponent({
  label: '@kueski-consumer-portal/containers/pages/Payment',
  loader: () => import(/* webpackChunkName: "Repayments" */ '@kueski-consumer-portal/containers/pages/Payment'),
  modules: [],
});

export const RepaymentsPaymentMethods = LoadableComponent({
  label: '@kueski-consumer-portal/containers/pages/PaymentMethods',
  loader: () => import(/* webpackChunkName: "Repayments" */ '@kueski-consumer-portal/containers/pages/PaymentMethods'),
  modules: [],
});

export const SavingsPage = LoadableComponent({
  label: '@kueski-consumer-portal/containers/pages/Savings',
  loader: () => import(/* webpackChunkName: "Savings" */ '@kueski-consumer-portal/containers/pages/Savings'),
  modules: [],
});

export const AutomaticRefundsPage = LoadableComponent({
  label: '@kueski-consumer-portal/containers/pages/Refunds',
  loader: () => import(/* webpackChunkName: "Savings" */ '@kueski-consumer-portal/containers/pages/Refunds'),
  modules: [],
});

export const StatementsPage = LoadableComponent({
  label: '@kueski-consumer-portal/containers/pages/Statements',
  loader: () => import(/* webpackChunkName: "Statements" */ '@kueski-consumer-portal/containers/pages/Statements'),
  modules: [],
});

export const Account = LoadableComponent({
  label: 'Containers/pages/Account',
  loader: () => import(/* webpackChunkName: "Account" */ 'Containers/pages/Account'),
  modules: [],
});

export const AccountContact = LoadableComponent({
  label: 'Containers/pages/Account/Contact',
  loader: () => import(/* webpackChunkName: "Account" */ 'Containers/pages/Account/Contact'),
  modules: [],
});

export const AboutKueski = LoadableComponent({
  label: 'Containers/pages/AboutKueski',
  loader: () => import(/* webpackChunkName: "AboutKueski" */ 'Containers/pages/AboutKueski'),
  modules: [],
});

export const DomicSubscription = LoadableComponent({
  label: '@kueski-consumer-portal/containers/pages/DomicSubscription',
  loader: () => import(/* webpackChunkName: "DomicSubscription" */ '@kueski-consumer-portal/containers/pages/DomicSubscription'),
  modules: [],
});

export const AccountAdd = LoadableComponent({
  label: 'Containers/pages/AccountLanding/AccountAddLanding.page.tsx',
  loader: () => import(/* webpackChunkName: "AccountAdd" */ 'Containers/pages/Account/AccountAdd.page'),
  modules: [],
});

export const ExternalError = LoadableComponent({
  label: 'Components/Errors/ExternalError',
  loader: () => import(/* webpackChunkName: "ExternalError" */ 'Components/Errors/ExternalError'),
  modules: [],
});

export const UserVerification = LoadableComponent({
  label: 'Containers/pages/Verification/UserVerification',
  loader: () => import(/* webpackChunkName: "UserVerification" */ 'Containers/pages/Verification/UserVerification'),
  modules: [],
});

export const UserVerificationResult = LoadableComponent({
  label: 'Containers/pages/Verification/UserVerification/UserVerificationResult',
  loader: () => import(/* webpackChunkName: "UserVerification" */ 'Containers/pages/Verification/UserVerification/UserVerificationResult'),
  modules: [],
});

export const EmailVerificationToken = LoadableComponent({
  label: 'Redesign_Funnel/containers/pages/EmailVerification/EmailVerificationToken',
  loader: () => import(/* webpackChunkName: "EmailVerificationToken" */ 'Redesign_Funnel/containers/pages/EmailVerification/EmailVerificationToken'),
  modules: [],
});

export const Verification2FA = LoadableComponent({
  label: 'Src/2fa',
  loader: () => import(/* webpackChunkName: "Verification2FA" */ 'Src/2fa'),
  modules: [],
});
